import TYPES from '../../types';

// Domain
import { EmergencyFundGoalMaximumMonthsCalculationEntity } from '@/modules/flagship/emergency-fund-investor-goal-calculator/domain/entities/emergency-fund-goal-maximum-months-calculation-entity';
import { EmergencyFundInvestorGoalCalculatorRepository } from '@/modules/flagship/emergency-fund-investor-goal-calculator/domain/repositories/emergency-fund-investor-goal-calculator-repository';
import { EmergencyFundGoalMaximumMonthsCalculationDto } from '@/modules/flagship/emergency-fund-investor-goal-calculator/domain/dtos/emergency-fund-goal-maximum-months-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Query from '@/modules/shared/domain/use-cases/query';
import Inject from '@/modules/shared/domain/di/inject';

@Injectable()
class CalculateCustomGoalMaximumMonthsQuery extends Query<
  Promise<EmergencyFundGoalMaximumMonthsCalculationEntity>
> {
  @Inject(TYPES.EMERGENCY_FUND_INVESTOR_GOAL_CALCULATOR_REPOSITORY)
  private readonly repository!: EmergencyFundInvestorGoalCalculatorRepository;

  internalExecute(
    payload: EmergencyFundGoalMaximumMonthsCalculationDto,
  ): Promise<EmergencyFundGoalMaximumMonthsCalculationEntity> {
    return this.repository.calculateMaximumInitialMonths(payload);
  }
}

export default CalculateCustomGoalMaximumMonthsQuery;
